<template>
    <tr 
        class="gz-table__checkup__row"
        :class="{'gz-table__checkup__row_passed': item.attributes.status === 'PASSED', 'gz-table__checkup__row_failed': item.attributes.status === 'FAILED'}"
    >
        <td>
            <span class="icon-calendar-classic"></span>
            <span>&nbsp;{{ item.attributes.date | moment('DD.MM.YYYY') }}</span>
        </td>
        <td>
            <StaffInfo :uid="item.attributes.uid"/>
        </td>
        <td>
            <span v-if="item.attributes.actnumber">№&nbsp;{{ item.attributes.actnumber }}&nbsp;&nbsp;</span>
            <button 
                v-if="isAdmin() && !item.attributes.pid"
                class="gz-button_small gz-button_radius-5 gz-button_white"
                @click="$router.push({ 
                    name: 'certificate', 
                    params: { 
                        bid: item.attributes.bid, 
                        act: item.attributes.actnumber,
                        date: item.attributes.date
                    } 
                })"
            >создать акт</button>
        </td>
        <td>
            <span v-if="item.attributes.status === 'PASSED'" class="icon-checkmark"></span>
            <span>&nbsp;&nbsp;{{ mapType(item.attributes.status, $store.getters['filtersCheckupStatus']) }}</span>
        </td>
        <td>
            <div v-if="isVerified()">
                <span class="icon-checkmark"></span>
                <span>&nbsp;&nbsp;Верифицированно</span>
            </div>
            <div v-if="!isVerified() && item.attributes.status === 'PASSED'">
                <span class="icon-hourglass"></span>
                <span>&nbsp;&nbsp;Ожидает верификации</span>
            </div>
        </td>
        <td>
            <span 
                v-if="item.attributes.pics.length" 
                class="icon-images"
                @click="openImageGallery()"
            >&nbsp;{{ item.attributes.pics.length }}</span>
        </td>
        <td>
            <span v-if="item.attributes.notes">&nbsp;&nbsp;{{ item.attributes.notes }}</span>
        </td>
        <td class="gz-table__checkup__row__actions">
            <button
                v-if="item.attributes.status === 'VISIT_CONFIRMED' || item.attributes.status === 'SCHEDULED'"
                @click="isWaitingOn(item.id)"
                class="gz-icon_cercle gz-icon_cercle_default"
                :class="{'gz-icon_cercle_accent': item.attributes.status === 'VISIT_CONFIRMED'}"
                title="Изменить статус ожидания"><span class="icon-mobile-alt-solid"
            ></span></button>

            <button
                v-if="isAdmin() && item.attributes.status === 'PASSED'"
                @click="verify(item.id)"
                class="gz-icon_cercle gz-icon_cercle_default"
                :class="{'gz-icon_cercle_accent_verified': isVerified()}"
                :title="isVerified() ? 'Отменить верификацию' : 'Верифицировать'"><span class="icon-checkmark"
            ></span></button>

            <button
                v-if="!isVerified()"
                @click="editCheckup()"
                class="gz-icon_cercle gz-icon_cercle_default"
                title="Редактировать"
            ><span class="icon-pencil"></span></button>
            <button
                v-if="isVerified() && isAdmin()"
                @click="editCheckup()"
                class="gz-icon_cercle gz-icon_cercle_default"
                title="Редактировать"
            ><span class="icon-pencil"></span></button>

            <button 
                v-if="!isVerified()"
                @click="disableCheckup(item)"
                class="gz-icon_cercle gz-icon_cercle_default"
                title="Удалить"
            ><span class="icon-cross"></span></button>
        </td>
    </tr>
</template>

<script>
import Checkup from '@/components/custom/admin/views/addresses/BaseCheckup'
import StaffInfo from '@/components/custom/admin/views/staff/BaseStaffInfoBlock'
import mapType from '@/mixins/utils/types-mapper'
import ImageGalleryModal from '@/components/custom/admin/modals/ImageGallery'

export default {
    name: 'CheckupRow',

    mixins: [mapType],
    props: {
        item: Object
    },
    components: {
        StaffInfo,
        Checkup
    },
    data() {
        return {
            isWaitingstatus: false,
            isVerifiedStatus: this.item.attributes.verifiedByUid ? true : false
        }
    },
    methods: {
        verify(id) {
            let checkupData = this.item.attributes

            if (this.isVerifiedStatus) checkupData.verifiedByUid = ''
            else checkupData.verifiedByUid = this.$store.getters['authUserId']

            this.$axios({
                method: 'PATCH',
                url: `checkup/${id}`,
                data: {
                    data: {
                        type: 'checkup',
                        id: id,
                        attributes: checkupData
                    }
                }
            })
            .then(() => {
                this.isVerifiedStatus = !this.isVerifiedStatus
                this.$store.dispatch('modalNotificationMessageOpen', ['Проверка верифицированна'])
            })
            .catch(err => {
                console.error('Ошибка верификации проверки: ', err)
                this.$store.dispatch('modalNotificationMessageOpen', 
                ['Ошибка при попытке верифицировать проверку. Возможно у вас недостаточно прав или связь с сервером прервалась.'])
            }) 
        },
        isVerified() {
            if (this.item.attributes.verifiedByUid) {
            //Если верифицирован
                return true
            } else {
                return false
            }
        },
        isWaitingOn(id) {
            let checkupData = this.item.attributes

            if (this.isWaitingstatus) checkupData.status = 'SCHEDULED'
            else checkupData.status = 'VISIT_CONFIRMED'

            this.$axios({
                method: 'PATCH',
                url: `checkup/${id}`,
                data: {
                    data: {
                        type: 'checkup',
                        id: id,
                        attributes: checkupData
                    }
                }
            })
            .then(() => {
                this.isWaitingstatus = !this.isWaitingstatus
                this.$store.dispatch('modalNotificationMessageOpen', ['Статус изменен'])
            })
            .catch(err => {
                console.error('Ошибка установки статуса ожидания: ', err)
                this.$store.dispatch('modalNotificationMessageOpen', 
                ['Ошибка при попытке изменить статус ожидания. Возможно у вас недостаточно прав или связь с сервером прервалась.'])
            }) 
        },
        editCheckup() {
            this.$store.dispatch('modalOpen', {
                component: Checkup,
                data: this.item
            })
        },
        disableCheckup(item) {
            if (confirm('Вы уверенны, что хотите удалить запись?')) {
                let checkup = this.item
                checkup.attributes.status = 'DELETED'

                this.$axios({
                    method: 'PATCH',
                    url: 'checkup/' + item.id,
                    data: {data: checkup} 
                })
                .then(() => {
                    this.$store.dispatch('addressCheckupStatus')
                })
                .catch(err => {
                    console.error('Ошибка удаления проверки: ', err.response)
                })
            }
        },
        openImageGallery() {
            this.$store.dispatch('modalOpen', {
                component: ImageGalleryModal,

                data: {
                    images: this.item.attributes.pics
                }
            })
        }
    }
}
</script>